import { render, staticRenderFns } from "./EventoTextEditors.vue?vue&type=template&id=4c673e0a"
import script from "./EventoTextEditors.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoTextEditors.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports